import * as THREE from 'three';

const material = new THREE.MeshStandardMaterial({ color: '#4a4438', roughness: 1 });

/** Grows/shrinks with pollution — the single most legible "score readout" prop. */
export class TrashPile {
  readonly group = new THREE.Group();
  private readonly pieces: THREE.Mesh[] = [];

  constructor(position: THREE.Vector3, pieceCount = 10) {
    for (let i = 0; i < pieceCount; i += 1) {
      const size = 0.18 + Math.random() * 0.22;
      const piece = new THREE.Mesh(new THREE.BoxGeometry(size, size, size), material);
      const angle = (i / pieceCount) * Math.PI * 2;
      const radius = Math.random() * 0.6;
      piece.position.set(Math.cos(angle) * radius, size / 2, Math.sin(angle) * radius);
      piece.rotation.y = Math.random() * Math.PI;
      piece.castShadow = true;
      this.pieces.push(piece);
      this.group.add(piece);
    }
    this.group.position.copy(position);
    this.setAmount(0.5);
  }

  /** @param amount 0 (no trash visible) to 1 (full pile) */
  setAmount(amount: number): void {
    const visibleCount = Math.round(this.pieces.length * THREE.MathUtils.clamp(amount, 0, 1));
    this.pieces.forEach((piece, index) => {
      piece.visible = index < visibleCount;
    });
  }

  dispose(): void {
    for (const piece of this.pieces) piece.geometry.dispose();
  }
}

export function disposeTrashPileMaterial(): void {
  material.dispose();
}
